module.exports = __webpack_public_path__ + "fonts/AvertaStd-Regular.19b8f54e.ttf";